import {TimeUnit} from 'common/widgets/date-range-picker/models/types';

// matches webapp/custom_alerts/models.py
export const CUSTOM_ALERT_FREQUENCY = {
  Hour: 0,
  Day: 1,
  Week: 2,
  Month: 3,
  FiveMinutes: 4,
};

export enum CUSTOM_ALERT_FREQUENCY_ENUM {
  Hour = 0,
  Day = 1,
  Week = 2,
  Month = 3,
  FiveMinutes = 4,
}

export const ANY_VALUE = `$any_value`;

export const CUSTOM_ALERT_OPERATOR = {
  above: `>`,
  below: `<`,
  outsideRangeExcluding: `!<=x<=`,
};

export const CUSTOM_ALERT_CONDITION_TEXT = {
  increase: `increase`,
  decrease: `decrease`,
  increaseBy: `increase-by`,
  decreaseBy: `decrease-by`,
};

export const CUSTOM_ALERT_VALUE_TYPE = {
  absolute: `absolute`,
  percent: `percent`,
};

export const CUSTOM_ALERT_TYPE = {
  absolute: `absolute`,
  anomaly: `anomaly`,
  relativePercent: `relative-percent`,
  relativeValue: `relative-value`,
};

export const CUSTOM_ALERT_CRITERIA_TYPE = {
  anomalyDetection: `anomaly_detection`,
  threshold: `threshold`,
};

export const CONFIDENCE_INTERVAL_OPTIONS = {
  [`95%`]: 0.95,
  [`98%`]: 0.98,
  [`99%`]: 0.99,
};

export const ANOMALY_DETECTION_TRAINING_MODE = {
  agile: `agile`,
  robust: `robust`,
  rigorous: `rigorous`,
};

export const DEFAULT_ALERT_NAME = `Untitled Alert`;

export const CUSTOM_ALERT_TRACKING_EVENTS = {
  OPENED_MODAL: `[Custom Alerts] Opened custom alert modal`,
  DISMISSED_MODAL: `[Custom Alerts] Dismissed custom alert modal`,
  CRITERIA_TYPE_CHANGED: `[Custom Alerts] Alert criteria type changed`,
  CREATED: `[Custom Alerts] Created custom alert`,
  UPDATED: `[Custom Alerts] Updated custom alert`,
  FAILED_TO_CREATE: `[Custom Alerts] Failed to create custom alert`,
  FAILED_TO_UPDATE: `[Custom Alerts] Failed to update custom alert`,
} as const;

export const CUSTOM_ALERT_VALIDATION_ERROR = {
  INVALID_EMAIL: `Invalid email address`,
  INVALID_NAME: `Invalid alert name`,
  INVALID_THRESHOLD: `Invalid threshold: must be a number`,
  INVALID_RATIO_THRESHOLD: `Invalid threshold: must be between 0% and 100%`,
  INVALID_RELATIVE_PERCENTAGE: `Invalid threshold: must be 0% or above`,
  MISSING_VALUE: `Please select a value for each key.`,
};

// TODO a full list of supported result keys/values when we need to support more result types for funnels
export const CUSTOM_ALERT_FUNNELS_DEFAULT_KEYS = [
  {
    name: `$step`,
    displayName: `Step`,
    values: [`$last`],
    displayValues: [`Last`],
    isPercentage: false,
  },
  {
    name: `$analysis`,
    displayName: `Analysis`,
    values: [`$overall_conv_ratio`],
    displayValues: [`Overall conversion rate`],
    isPercentage: true,
  },
];

export const ANOMALY_DETECTION_DATE_RANGE_OVERRIDE = {
  [TimeUnit.Hour]: {unit: TimeUnit.Day, value: 2},
  [TimeUnit.Day]: {unit: TimeUnit.Day, value: 7},
  [TimeUnit.Week]: {unit: TimeUnit.Week, value: 8},
  [TimeUnit.Month]: {unit: TimeUnit.Month, value: 12},
  [TimeUnit.Quarter]: {unit: TimeUnit.Quarter, value: 4},
};

export const ANOMALY_DETECTION_ALLOWED_TIME_UNITS = [
  TimeUnit.Hour,
  TimeUnit.Day,
  TimeUnit.Week,
  TimeUnit.Month,
  TimeUnit.Quarter,
];

export const MATH_TO_FUNNEL_STEPS_METRIC = {
  conversion_rate: `overall_conv_ratio`,
  conversion_rate_unique: `overall_conv_ratio`,
  conversion_rate_total: `overall_conv_ratio`,
  conversion_rate_session: `overall_conv_ratio`,
  unique: `count`,
  general: `count`,
  session: `count`,
  total: `property_sum`,
  average: `property_avg`,
  median: `property_median`,
  unique_values: `property_unique_values`,
  p25: `property_p25`,
  p75: `property_p75`,
  p90: `property_p90`,
  p99: `property_p99`,
  min: `property_min`,
  max: `property_max`,
};

// Notification windows constants
// Days 0-6 are current week, days 7-13 are next week
export const DAYS_OF_WEEK = [
  {value: 0, label: `Monday`},
  {value: 1, label: `Tuesday`},
  {value: 2, label: `Wednesday`},
  {value: 3, label: `Thursday`},
  {value: 4, label: `Friday`},
  {value: 5, label: `Saturday`},
  {value: 6, label: `Sunday`},
  {value: 7, label: `Next Monday`},
  {value: 8, label: `Next Tuesday`},
  {value: 9, label: `Next Wednesday`},
  {value: 10, label: `Next Thursday`},
  {value: 11, label: `Next Friday`},
  {value: 12, label: `Next Saturday`},
  {value: 13, label: `Next Sunday`},
] as const;
